var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deposit-amount" },
    [
      _c("p", { class: [{ "required-flag": _vm.canUpdate }, "blod-p"] }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("tenantProjects.depositAmount")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.isEngineer
        ? _c("div", { staticClass: "btns" }, [
            _c("div", { staticClass: "notify-btns" }, [
              _vm.canUpdate && !_vm.canNotifyAccounting
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      on: { click: _vm.notifyPM },
                    },
                    [_vm._v(_vm._s(_vm.$t("tenantProjects.notifyPM")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canNotifyAccounting && !_vm.isWaived
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue margin-left-15",
                      on: { click: _vm.notifyAccounting },
                    },
                    [_vm._v(_vm._s(_vm.$t("tenantProjects.notifyAccounting")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canNotifyAccounting && _vm.isWaived
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange margin-left-15",
                      on: { click: _vm.confirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.confirm")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "deposit-notify-info" },
                [
                  _vm.notifyPMInfo && _vm.canRead
                    ? _c("i", { staticClass: "gray-font notify-pm-info" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("tenantProjects.notifyPMByAt", [
                                _vm.notifyPMInfo.by,
                                _vm.notifyPMInfo.time,
                              ])
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notifyAccountingInfo
                    ? _c(
                        "i",
                        { staticClass: "gray-font notify-accounting-info" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("tenantProjects.notifyAccountingByAt", [
                                  _vm.notifyAccountingInfo.by,
                                  _vm.notifyAccountingInfo.time,
                                ])
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmInfo && _vm.canRead
                    ? _c("i", { staticClass: "gray-font confirm-info" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("tenantProjects.confirmByAt", [
                                _vm.confirmInfo.by,
                                _vm.confirmInfo.time,
                              ])
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notifyAccountingInfo
                    ? _c("HKLViewLayout", { attrs: { checkIsHKL: true } }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-[12px] underline",
                            on: {
                              click: function () {
                                return _vm.openDepositModal()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("tenantProjects.depositHistory")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.enableWorkPermitsFeature
              ? _c(
                  "div",
                  { staticClass: "notify-contractor" },
                  [
                    _vm.canUpdate
                      ? _c(
                          "HKLButton",
                          {
                            attrs: { action: "allowRefund", color: "darkblue" },
                            on: { click: _vm.allowContractorRefund },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t("tenantProjects.notifyContractor")
                                ) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowContrRefundInfo
                      ? _c("div", { staticClass: "deposit-notify-info" }, [
                          _c("i", { staticClass: "gray-font" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "tenantProjects.allowContractorRefundByAt",
                                    [
                                      _vm.allowContrRefundInfo.by,
                                      _vm.allowContrRefundInfo.time,
                                    ]
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEngineer
        ? _c("div", { staticClass: "deposit-amount__content" }, [
            _c(
              "div",
              { staticClass: "choose-deposit-amount" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.isWaived,
                      expression: "isWaived",
                    },
                  ],
                  attrs: { type: "radio", disabled: !_vm.canUpdate },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.isWaived, false),
                  },
                  on: {
                    change: [
                      function ($event) {
                        _vm.isWaived = false
                      },
                      _vm.scheduleDirtyStateCheck,
                    ],
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "deposit-amount-label" }, [
                  _vm._v(_vm._s(_vm.$t("tenantProjects.depositAmount")) + " "),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "deposit-amount-label currency-prefix" },
                  [_vm._v(_vm._s(_vm.$globalProps.getCurrency()))]
                ),
                _vm._v(" "),
                _c("InputField", {
                  staticClass: "input-deposit-amount",
                  attrs: {
                    readonly: !_vm.canUpdate && !_vm.isEditingAmount,
                    showColon: false,
                    placeholder: "0.00",
                    showFlag: false,
                    value: _vm.amount,
                    showEmptyDash: true,
                    readonlyAsInput:
                      _vm.isWaived ||
                      (_vm.isNotifiedPM && !_vm.isEditingAmount),
                    inputTip: _vm.hintString,
                    inputCheckType: "decimal",
                    pattern: _vm.regex.decimal,
                    required: !_vm.isWaived,
                    parentNode: _vm.FORM_SRC_PROJECT_CONTROL,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.updateAmount(val)
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isNotifiedPM &&
                        !_vm.isEditingAmount &&
                        !_vm.isWaived &&
                        _vm.canUpdate,
                      expression:
                        "isNotifiedPM && !isEditingAmount && !isWaived && canUpdate",
                    },
                  ],
                  staticClass: "fa fa-pencil",
                  on: {
                    click: function ($event) {
                      _vm.isEditingAmount = true
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "waived-option" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isWaived,
                    expression: "isWaived",
                  },
                ],
                attrs: { type: "radio", disabled: !_vm.canUpdate },
                domProps: { value: true, checked: _vm._q(_vm.isWaived, true) },
                on: {
                  click: _vm.resetAmount,
                  change: [
                    function ($event) {
                      _vm.isWaived = true
                    },
                    _vm.scheduleDirtyStateCheck,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "deposit-amount-label" }, [
                _vm._v(_vm._s(_vm.$t("tenantProjects.waiveDepositWithExtra"))),
              ]),
            ]),
            _vm._v(" "),
            !_vm.isWaived
              ? _c("div", { staticClass: "waived-option" }, [
                  _c(
                    "p",
                    { class: [{ "required-flag": _vm.canUpdate }, "blod-p"] },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tenantProjects.debitNote")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "plsSendTo" }, [
                    _vm._v(_vm._s(_vm.$t("tenantProjects.plsSendTo"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isDirect,
                          expression: "isDirect",
                        },
                      ],
                      attrs: { type: "radio", disabled: !_vm.canUpdate },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.isDirect, true),
                      },
                      on: {
                        click: _vm.resetTenantMailing,
                        change: [
                          function ($event) {
                            _vm.isDirect = true
                          },
                          _vm.scheduleDirtyStateCheck,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "deposit-amount-label" }, [
                      _vm._v(_vm._s(_vm.$t("tenantProjects.TenantAddress"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        { "error-highlight": _vm.buildingErr },
                        "tenant-mailing-address",
                      ],
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isDirect,
                            expression: "isDirect",
                          },
                        ],
                        attrs: { type: "radio", disabled: !_vm.canUpdate },
                        domProps: {
                          value: false,
                          checked: _vm._q(_vm.isDirect, false),
                        },
                        on: {
                          change: [
                            function ($event) {
                              _vm.isDirect = false
                            },
                            _vm.scheduleDirtyStateCheck,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("InputField", {
                        class: _vm.mailInputClass,
                        attrs: {
                          placeholder: _vm.$t("tenantProjects.staffNamePH"),
                          readonly: !_vm.canUpdate,
                          showColon: false,
                          showFlag: false,
                          value: _vm.payeeName,
                          readonlyAsInput: _vm.isDirect,
                          required: !_vm.isDirect,
                          parentNode: _vm.FORM_SRC_PROJECT_CONTROL,
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.updatePayeeName(val)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("at")))]),
                      _vm._v(" "),
                      _c("HKLSelect", {
                        staticClass: "tenant-mailing-address__buidling",
                        attrs: {
                          value: _vm.address || undefined,
                          options: _vm.buildingHklOptions,
                          showSearch: true,
                          placeholder: "",
                          disabled: _vm.isDirect || !_vm.canUpdate,
                        },
                        on: {
                          change: function (val) {
                            return _vm.updateAddress(val)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("tenantProjects.byInternalMail"))),
                      ]),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm.isUserNotifyAccounting
        ? _c("div", [
            _c("label", { staticClass: "medium-size margin-right-15" }, [
              _vm._v(_vm._s(_vm.$globalProps.getCurrency() + " ") + " "),
              _c("span", { staticClass: "blod-p" }, [
                _vm._v(_vm._s(_vm.showAmount)),
              ]),
            ]),
          ])
        : _c("div", [_vm._v("\n    " + _vm._s(_vm.$t("emptyValue")) + "\n  ")]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "deposit-input-modal",
          staticClass: "deposit-input-modal",
          attrs: {
            modalType: "small-modal",
            showCloseBtn: false,
            modalId: "deposit-input-modal_" + _vm.tenantProjectId,
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenantProjects.inputAccountingHint") + " ") +
                  "\n      "
              ),
              _c("span", [_vm._v(_vm._s(_vm.accountingEmail || "--"))]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              { staticClass: "btn--darkblue", on: { click: _vm.closeModal } },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--orange",
                on: { click: _vm.sendEmailToAccounting },
              },
              [_vm._v(_vm._s(_vm.$t("action.send")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isUserNotifyAccounting
        ? _c(
            "HKLModal",
            {
              ref: "depositModal",
              attrs: {
                size: "large",
                hasCancelBtn: false,
                title: _vm.$t("tenantProjects.depositHistory"),
              },
            },
            [
              _c("HKLTable", {
                attrs: {
                  columns: _vm.columns,
                  dataSource: _vm.parsedHistories,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }